import { useCallback, useEffect, useMemo, useState } from 'react';
import { useUser } from '~/api/hooks/useGetAccount';
import { useAccountApi } from '~/features/account/hooks/useAccountApi';
import { useRegion } from '~/features/region/hooks/useRegion';
import { regionService } from '~/features/region/regionService';
import { useLocale } from '~/hooks/useLocale';
import { mailAddress, text, title } from '~/masterdata/mailto';

export const useMailto = () => {
  const { getAccountRequest } = useAccountApi();
  const [mailtoText, setMailtoText] = useState<string>();
  const { data: user } = useUser();
  const { regionCode } = useRegion();
  const locale = useLocale();

  const lang = useMemo(() => (locale.isJapanese ? 'ja' : 'en'), [locale]);

  const createMailtoData = useCallback((mailAddress: string, title: string, text: string) => {
    return `${mailAddress}?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(text)}`;
  }, []);

  useEffect(() => {
    if (!user?.asics_id && getAccountRequest) {
      getAccountRequest({});
    }

    if (!regionCode || !user?.asics_id) return;

    const regionInfo = regionService.getARegionName(regionCode);
    setMailtoText(
      createMailtoData(mailAddress, title[lang], text(user.asics_id, lang, regionInfo)),
    );
  }, [user?.asics_id, regionCode, lang]);

  return { mailtoText };
};
